import { render } from "./tenants.vue?vue&type=template&id=4be6a1bc"
import script from "./tenants.vue?vue&type=script&lang=js"
export * from "./tenants.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__